import { useEffect, useRef, useState } from "react";

import YouTube from "react-youtube";

import { getYouTubeVideoId } from "../../../../../utils/getYouTubeVideoId";

import Button from "../../ButtonComponent";
import HeaderModule from "../../ModuleHeaderComponent";

import { BUTTON_VARIANTS } from "../../constant";

import styles from "./styles.module.scss";
import Shimmer from "../../ShimmerComponent";

const InclusiveEducationVideo = (props) => {
  const {inclusiveEducationContent , isLoading , handleClick , handleBackClick , isPending , isFetching} = props;

  const [isVideoCompleted, setIsVideoCompleted] = useState(false);

  const playerRef = useRef(null);
  const maxWatchedTime = useRef(0);

  if (isLoading) {
    <div>Loading...</div>;
  }

  const { data: inclusiveEducationContentData } = inclusiveEducationContent || {};

  const { response } = inclusiveEducationContentData || {};

  const videoData = response?.videos?.[0];

  const videoStatus = videoData?.videoStatus;

  const videoId = videoData?.url ? getYouTubeVideoId(videoData?.url.replace('watch/','watch?v=')) : null;

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: 0,
      controls: 0,
      modestbranding: 1,
      rel: 0,
      fs: 0,
      iv_load_policy: 3, // hide annotations
      disablekb: 1,     
    },
  };

  const onPlayerReady = (event) => {
    playerRef.current = event.target;
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      if (
        !playerRef.current ||
        typeof playerRef.current.getCurrentTime !== "function"
      )
        return;

      const currentTime = await playerRef.current.getCurrentTime();

      const allowedTime = maxWatchedTime.current + 2;

      if (currentTime > allowedTime) {
        console.warn("Skipping not allowed!");
        playerRef.current.seekTo(maxWatchedTime.current, true);
      } else {
        if (currentTime > maxWatchedTime.current) {
          maxWatchedTime.current = currentTime;
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleVideoEnd = () => {
    if (playerRef.current) {
      playerRef.current.seekTo(0, true);
      playerRef.current.pauseVideo();
    }

    setIsVideoCompleted(true);
  };

  return (
    <>
      <HeaderModule
        title={videoData?.title}
        className={styles["header-title"]}
        onBackClick={handleBackClick}
      />

{ isLoading || isFetching ?
     <Shimmer
      width="65%"
      height="75vh"
      borderRadius="14px" 
      style={{margin:'20px auto'}}
      />
   :     
   <div className={styles["video-container-wrapper"]}>
        <div className={styles["video-player"]}>
          {videoId && (
            <YouTube
              videoId={videoId}
              opts={opts}
              className={styles["video-container"]}
              onReady={onPlayerReady}
              onEnd={handleVideoEnd}
            />
          )}
        </div>
      </div>}

      <div className={styles["bottom-wrapper"]}>
        <Button
          label="Continue"
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          disabled={!(videoStatus === 1 || isVideoCompleted) || isPending}
          className={styles["button-class"]}
          onClick={handleClick}
        />
      </div>
    </>
  );
};

export default InclusiveEducationVideo;
